import _ from 'underscore';
import { ApiRoute } from '@ve/types';

type RouteReferenceIndex = {
    [key: string]: ApiRoute
};

export default ({ routeIds, routeReferenceIndex }: { routeIds: string[], routeReferenceIndex: RouteReferenceIndex }): ApiRoute[] => _.map(routeIds, (routeId: keyof RouteReferenceIndex) => routeReferenceIndex[routeId]);